const clinicType = process.env.REACT_APP_CETRA_CLINIC_TYPE;
const isProd = process.env.REACT_APP_USER_API_URL.includes('prod');

const pricingDetails = {
    physio: {
        Student: {
            accountType: 'Student',
            productId: isProd ? 'prod_QzePKP8z4oBihu' : 'prod_QzdOB5hKnkniqg',
            priceMonthlyId: isProd ? 'price_1SAw3qL2Uy8HcDMu4QEoZY7r' : 'price_1SAso9L2Uy8HcDMuAwWrSgMk',
            priceMonthly: 4.99,
            priceAnnually: 56.88,
            priceAnnuallyId: isProd ? 'price_1SAw4BL2Uy8HcDMuUoDwkE6E' : 'price_1SAtGOL2Uy8HcDMuTqXqkNnw',
            specialProductId: isProd ? 'prod_RFKk8mkd3Zkwks' : 'prod_RFKSoXW6RYGkbm',
            // prettier-ignore
            specialPriceAnnually: 35.00,
            specialPriceAnnuallyId: isProd ? 'price_1QMq4kL2Uy8HcDMuyF2gbHbF' : 'price_1QMpnyL2Uy8HcDMuOvIZdWEL',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'Basic customer support',
                'Interactive whiteboard',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'RMpw83',
        },
        Professional: {
            accountType: 'Professional',
            productId: isProd ? 'prod_QzePOrvA7KzYi1' : 'prod_QzdKp7VSGHf2ps',
            priceMonthlyId: isProd ? 'price_1SAw6BL2Uy8HcDMuCSKASz2f' : 'price_1SAtHhL2Uy8HcDMuW6Htofhq',
            priceMonthly: 9.99,
            priceAnnually: 113.88,
            priceAnnuallyId: isProd ? 'price_1SAw6VL2Uy8HcDMulO79hF9p' : 'price_1SAtILL2Uy8HcDMuWBvDna7U',
            specialProductId: isProd ? 'prod_RFKkaPhqKVavgU' : 'prod_RFKVXtXmocgqd4',
            // prettier-ignore
            specialPriceAnnually: 50.00,
            specialPriceAnnuallyId: isProd ? 'price_1QMq4mL2Uy8HcDMuqNc9t6iI' : 'price_1QMpqXL2Uy8HcDMu0pm8n8QI',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'Unlimited digital sharing',
                'Clinic name on all handouts',
                'Basic customer support',
                'Interactive whiteboard',
                'Whiteboard client library',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'RsheG7',
        },
        'Professional - 14 day FREE trial': {
            accountType: 'Professional',
            productId: 'trial',
            priceMonthlyId: 'trial',
            priceMonthly: 0,
            priceAnnually: 0,
            priceAnnuallyId: 'trial',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'Unlimited digital sharing',
                'Clinic name on all handouts',
                'Basic customer support',
                'Interactive whiteboard',
                'Whiteboard client library',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'XJsU8z',
        },
        Clinic: {
            accountType: 'Clinic',
            productId: isProd ? 'prod_QzePeFEV48e8ue' : 'prod_QzdGnx6z4XIdKu',
            priceMonthlyId: isProd ? 'price_1SAw8OL2Uy8HcDMuC6P9WJBJ' : 'price_1SAtJWL2Uy8HcDMu61s2rnXW',
            priceMonthly: 49.99,
            priceAnnually: 569.88,
            priceAnnuallyId: isProd ? 'price_1SAw96L2Uy8HcDMuCAWaO6vG' : 'price_1SAtKBL2Uy8HcDMu1MmgDwih',
            specialProductId: isProd ? 'prod_RFKk3SItbfwmPZ' : 'prod_RFKVxZvBg2Cb19',
            // prettier-ignore
            specialPriceAnnually: 200.00,
            specialPriceAnnuallyId: isProd ? 'price_1QMq4oL2Uy8HcDMuTi5xex29' : 'price_1QMpqvL2Uy8HcDMuT3PmOH7b',
            benefits: [
                'Multi user access - up to 5 seats',
                'View all information handouts',
                'View all anatomy diagrams',
                'Unlimited digital sharing',
                'Ability to bundle handouts',
                'Custom branding on handouts',
                'Premium customer support',
                'Interactive whiteboard',
                'Whiteboard client library',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'R2xGUM',
        },
        Enterprise: {
            countType: 'Enterprise',
            benefits: [
                'Multi-user access – more than 5 users',
                'Multi-clinic access',
                'Shared content libraries',
                'View all information handouts',
                'View all anatomy diagrams',
                'Unlimited digital sharing',
                'Ability to bundle handouts',
                'Custom branding on handouts',
                'Premium customer support',
                'Interactive whiteboard',
                'Whiteboard client library',
            ],
            description:
                'Our enterprise plan is designed for larger organisations. This plan has advanced administrative and reporting functions, and is a cost effective option for institutions and businesses with multiple clinics or more than 5 users.',
            klaviyoListId: 'RsheG7', //TODO it needs a new klaviyo list
        },
    },
};

module.exports = pricingDetails[clinicType];
